import React, { useEffect } from 'react';
import { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Container,
  Divider,
  FormControlLabel,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  TextField,
  Typography,
  CircularProgress, // <--- ДОБАВЛЕНО
} from '@mui/material';

// ДОБАВЛЕНО: Иконка для наглядности
import SmartToyIcon from '@mui/icons-material/SmartToy';
import OpenInNewIcon from '@mui/icons-material/OpenInNew'; // Иконка для перехода

const UserProfile = ({
  canManageAccess = true,
  data,
  submitHandler,
  userInfo,
  alltypes,
  allRoles,
  allReports,
  checkedRoles,
  handleToggleRoles,
  permissionsRegistry,
  userPermissions,
  setUserPermissions,
  handleGenerateBotCode,
  isGeneratingCode,
}) => {
  const [loginInput, setLoginInput] = useState('');
  const [nameInput, setNameInput] = useState('');
  const [passwordInput, setPasswordInput] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [readOnly, setReafOnly] = useState(false);
  const [onlyStages, setOnlyStages] = useState(false);
  const [types, setTypes] = useState([]);
  const [reports, setReports] = useState([]);

  useEffect(() => {
    if (data) {
      setLoginInput(data?.login || '');
      setNameInput(data?.name || '');
      setPasswordInput('');
      setIsAdmin(data?.isAdmin || false);
      setReafOnly(data?.readOnly || false);
      setOnlyStages(data?.onlyStages || false);
      setTypes(data?.types || []);
      setReports(data?.reports || []);
    }
  }, [data]);

  const handlePermissionToggle = (resource, action) => (e) => {
    const checked = e.target.checked;
    const prev = userPermissions[resource] || {};
    const next = {
      ...userPermissions,
      [resource]: { ...prev, [action]: checked },
    };
    setUserPermissions(next);
    // тут можно сразу дергать setPermissions API или копить до submit
  };

  const handleTypeCheck = (id) => {
    if (types.includes(id)) {
      setTypes(types.filter((type) => type !== id));
    } else {
      setTypes([...types, id]);
    }
  };

  const handleReportCheck = (id) => {
    if (reports.includes(id)) {
      setReports(reports.filter((report) => report !== id));
    } else {
      setReports([...reports, id]);
    }
  };

  // Проверяем, подключен ли бот (ждём с бэка словарь messengerAccounts)
  const isMaxConnected = data?.messengerAccounts?.max;
  // Имя бота можно вынести в .env (например: domtat_bot)
  // const botName = process.env.REACT_APP_MAX_BOT_NAME || 'YOUR_BOT_NAME';

  // Получаем словарь подключенных аккаунтов (защита от undefined)
  const messengerAccounts = data?.messengerAccounts || {};
  console.log('messengerAccounts',messengerAccounts);
  const botName = process.env.REACT_APP_MAX_BOT_NAME || 'domtat_bot';

  // Создаем конфигурацию всех возможных ботов
  const AVAILABLE_BOTS = [
    {
      id: 'max',
      name: 'MAX Bot (Уведомления)',
      description: 'Получайте уведомления о задачах прямо в мессенджер',
      url: `https://max.ru/${botName}`,
      icon: <SmartToyIcon />
    }
    // В будущем сюда можно добавить: { id: 'tg', name: 'Telegram Bot', ... }
  ];

  // console.log('UserProfile', data);
  return (
    <div>
      {data && (
        <form
          onSubmit={(e) =>
            submitHandler(
              e,
              loginInput,
              nameInput,
              passwordInput,
              isAdmin,
              readOnly,
              onlyStages,
              types,
              reports,
            )
          }
          noValidate
          autoComplete='off'
        >
          <Stack spacing={2}>
            <TextField
              id='username'
              //ref={userRef}
              // autoComplete='off'
              onChange={(e) => setNameInput(e.target.value)}
              value={nameInput || ''}
              error={false}
              fullWidth
              //helperText={formik.touched.email && formik.errors.email}
              label='Имя'
              name='name'
              //onBlur={formik.handleBlur}
              //onChange={formik.handleChange}
              type='text'
              //value={formik.values.email}
            />
            <TextField
              id='login'
              //ref={userRef}
              // autoComplete='off'
              onChange={(e) => setLoginInput(e.target.value)}
              value={loginInput || ''}
              error={false}
              fullWidth
              //helperText={formik.touched.email && formik.errors.email}
              label='Логин'
              name='login'
              //onBlur={formik.handleBlur}
              //onChange={formik.handleChange}
              type='text'
              //value={formik.values.email}
            />
            <TextField
              id='password'
              autoComplete='off'
              onChange={(e) => setPasswordInput(e.target.value)}
              value={passwordInput || ''}
              //required
              error={false}
              fullWidth
              //helperText={'не ме'}
              //formik.touched.password && formik.errors.password
              //}
              label='Пароль'
              name='password'
              //onBlur={formik.handleBlur}
              //onChange={formik.handleChange}
              type='password'
              //value={formik.values.password}
            />
            {canManageAccess && userInfo?.isAdmin && !userInfo?.readOnly && (
              <>
                <FormControlLabel
                  onChange={(e) => setIsAdmin(e.target.checked)}
                  control={<Checkbox checked={isAdmin} />}
                  label='Администратор'
                />
              </>
            )}
          </Stack>
          {Array.isArray(alltypes) && alltypes.length > 0 && (
            <>
              <Divider />
              <Box sx={{ mt: 3, p: 0 }}>
                <Typography
                  variant='button'
                  display='block'
                  gutterBottom
                  sx={{ m: 0, p: 0 }}
                >
                  Доступные типы объектов:
                </Typography>
                <List
                  dense={true}
                  sx={{
                    width: '100%',
                    bgcolor: 'background.paper',
                    m: 0,
                    p: 0,
                  }}
                >
                  {Array.isArray(alltypes) &&
                    alltypes.length > 0 &&
                    alltypes.map((type) => {
                      const labelId = `checkbox-list-label-${type._id}`;

                      return (
                        <ListItem
                          key={type._id}
                          secondaryAction={
                            <Checkbox
                              edge='end'
                              checked={types?.includes(type._id) || false}
                              tabIndex={-1}
                              disableRipple
                              inputProps={{ 'aria-labelledby': labelId }}
                              onChange={() => handleTypeCheck(type._id)}
                            />
                          }
                          disablePadding
                        >
                          <ListItemButton role={undefined} dense>
                            <ListItemText id={labelId} primary={type?.title} />
                          </ListItemButton>
                        </ListItem>
                      );
                    })}
                </List>
              </Box>
            </>
          )}

          {Array.isArray(allRoles) && allRoles.length > 0 && (
            <>
              <Divider />
              <Box sx={{ mt: 3, p: 0 }}>
                <Typography
                  variant='button'
                  display='block'
                  gutterBottom
                  sx={{ m: 0, p: 0 }}
                >
                  {isAdmin ? 'Роли' : 'Мои права'}
                </Typography>
                <List
                  dense={true}
                  sx={{
                    width: '100%',
                    bgcolor: 'background.paper',
                    m: 0,
                    p: 0,
                  }}
                >
                  {allRoles.map((role, index) => {
                    const labelId = `checkbox-list-secondary-label-${role?.code}`;
                    return (
                      <ListItem
                        key={index}
                        secondaryAction={
                          <Checkbox
                            edge='end'
                            onChange={handleToggleRoles(role.code)}
                            checked={checkedRoles.includes(role.code)}
                            inputProps={{ 'aria-labelledby': labelId }}
                            tabIndex={-1}
                            disableRipple
                          />
                        }
                        disablePadding
                      >
                        <ListItemButton>
                          <ListItemText
                            id={labelId}
                            primary={`${role?.title}`}
                          />
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
                </List>
              </Box>
            </>
          )}
          <Divider />

          {Array.isArray(allReports) && allReports.length > 0 && (
            <>
              <Divider />
              <Box sx={{ mt: 3, p: 0 }}>
                <Typography
                  variant='button'
                  display='block'
                  gutterBottom
                  sx={{ m: 0, p: 0 }}
                >
                  Отчеты:
                </Typography>
                <List
                  dense={true}
                  sx={{
                    width: '100%',
                    // maxWidth: 360,
                    bgcolor: 'background.paper',
                    m: 0,
                    p: 0,
                  }}
                >
                  {Array.isArray(allReports) &&
                    allReports.length > 0 &&
                    allReports.map((report) => {
                      const labelId = `report-checkbox-list-label-${report.code}`;

                      return (
                        <ListItem
                          key={report.code}
                          secondaryAction={
                            <Checkbox
                              edge='end'
                              checked={reports?.includes(report.code) || false}
                              tabIndex={-1}
                              disableRipple
                              inputProps={{ 'aria-labelledby': labelId }}
                              onChange={() => handleReportCheck(report.code)}
                            />
                          }
                          disablePadding
                        >
                          <ListItemButton role={undefined} dense>
                            <ListItemText
                              id={labelId}
                              primary={report?.title}
                            />
                          </ListItemButton>
                        </ListItem>
                      );
                    })}
                </List>
              </Box>
            </>
          )}

          {userInfo?.isAdmin && permissionsRegistry && (
            <>
              <Divider />
              <Box sx={{ mt: 3, p: 0 }}>
                <Typography
                  variant='button'
                  display='block'
                  gutterBottom
                  sx={{ m: 0, p: 0 }}
                >
                  Права доступа к справочникам
                </Typography>

                {Object.entries(permissionsRegistry).map(([resource, cfg]) => (
                  <Box key={resource} sx={{ mt: 1 }}>
                    <Typography variant='subtitle2'>{cfg.label}</Typography>
                    <List dense sx={{ m: 0, p: 0 }}>
                      {Object.entries(cfg.actions).map(
                        ([actionKey, actionLabel]) => {
                          const checked = Boolean(
                            userPermissions?.[resource]?.[actionKey],
                          );
                          const id = `perm-${resource}-${actionKey}`;
                          return (
                            <ListItem
                              key={id}
                              disablePadding
                              secondaryAction={
                                <Checkbox
                                  edge='end'
                                  checked={checked}
                                  onChange={handlePermissionToggle(
                                    resource,
                                    actionKey,
                                  )}
                                  inputProps={{ 'aria-labelledby': id }}
                                />
                              }
                            >
                              <ListItemButton>
                                <ListItemText id={id} primary={actionLabel} />
                              </ListItemButton>
                            </ListItem>
                          );
                        },
                      )}
                    </List>
                  </Box>
                ))}
              </Box>
            </>
          )}

          <Divider sx={{ my: 3 }} />

          {/* ========================================================= */}
          {/* 🤖 СЕКЦИЯ ИНТЕГРАЦИИ С БОТАМИ (Гибридная схема)            */}
          {/* ========================================================= */}
          <Box sx={{ mt: 3, p: 0 }}>
            <Typography variant='button' display='block' gutterBottom>
              Интеграция с мессенджерами
            </Typography>





<Stack spacing={2} sx={{ mt: 1 }}>
              {AVAILABLE_BOTS.map((bot) => {
                // Проверяем, есть ли ID этого бота в объекте messengerAccounts юзера
                const isConnected = !!messengerAccounts[bot.id];

                return (
                  <Paper
                    key={bot.id}
                    variant='outlined'
                    sx={{
                      p: 2,
                      borderColor: isConnected ? 'success.main' : 'divider',
                      bgcolor: isConnected ? 'success.50' : 'transparent', // Легкая зеленая подсветка
                    }}
                  >
                    <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'flex-start', sm: 'center' }} spacing={2}>
                      
                      <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, gap: 2 }}>
                        {React.cloneElement(bot.icon, { color: isConnected ? 'success' : 'action' })}
                        <Box>
                          <Typography variant='subtitle1'>{bot.name}</Typography>
                          <Typography variant='body2' color='text.secondary'>
                            {isConnected 
                              ? 'Аккаунт успешно привязан' 
                              : bot.description}
                          </Typography>
                        </Box>
                      </Box>

                      {/* Кнопка перехода к боту, если уже подключен */}
                      {isConnected && (
                        <Button
                          variant="outlined"
                          color="success"
                          endIcon={<OpenInNewIcon />}
                          href={bot.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{ mt: { xs: 2, sm: 0 } }}
                        >
                          Перейти к боту
                        </Button>
                      )}
                    </Stack>

                    {/* Логика подключения, если НЕ подключен */}
                    {!isConnected && (
                      <Box sx={{ mt: 2 }}>
                        {!data?.botAuthCode ? (
                          <Button
                            variant='outlined'
                            onClick={handleGenerateBotCode}
                            disabled={isGeneratingCode}
                          >
                            {isGeneratingCode ? (
                              <CircularProgress size={24} />
                            ) : (
                              `Подключить ${bot.name}`
                            )}
                          </Button>
                        ) : (
                          <Box sx={{ bgcolor: 'action.hover', p: 2, borderRadius: 1 }}>
                            <Typography variant='subtitle2' gutterBottom>
                              Код для подключения сгенерирован!
                            </Typography>
                            <Typography variant='body2' sx={{ mb: 2 }}>
                              Нажмите кнопку ниже, чтобы перейти в приложение, или
                              отправьте боту <b>@{botName}</b> сообщение:
                            </Typography>

                            <Typography
                              variant='h6'
                              sx={{
                                fontFamily: 'monospace',
                                mb: 2,
                                color: 'primary.main',
                              }}
                            >
                              /auth {data.botAuthCode}
                            </Typography>

                            <Button
                              variant='contained'
                              color='primary'
                              href={`${bot.url}?start=${data.botAuthCode}`}
                              target='_blank'
                              rel='noopener noreferrer'
                            >
                              Перейти в {bot.name} (One-Click)
                            </Button>
                          </Box>
                        )}
                      </Box>
                    )}
                  </Paper>
                );
              })}
            </Stack>

          </Box>
          {/* ========================================================= */}

          {/* <Button
            onClick={(e) =>
              submitHandler(
                e,
                loginInput,
                nameInput,
                passwordInput,
                isAdmin,
                readOnly,
                onlyStages,
                types,
                reports,
              )
            }
            fullWidth
            size='large'
            sx={{ mt: 3 }}
            type='submit'
            variant='contained'
          >
            Сохранить
          </Button> */}
          <Button
            fullWidth
            size='large'
            sx={{ mt: 4 }}
            type='submit'
            variant='contained'
          >
            Сохранить
          </Button>
        </form>
      )}
    </div>
  );
};

export default UserProfile;
